// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  tokenSAS: '?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2023-06-09T11:50:23Z&st=2022-06-09T16:50:23Z&spr=https&sig=rAVwFxDSI6LjXMkTxkhEkwrgaD3B2GOMjDMz4qeKTsA%3D',
  storageAccountName : 'azstacsandboxndcprd'
  // production: false,
  // tokenSAS: '?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitf&se=2030-02-01T04:10:57Z&st=2030-01-31T20:10:57Z&spr=https,http&sig=j1674nB2sOmFXIIlzhWQWJhbd%2FokZRUeOSOWooxhac0%3D',
  // storageAccountName: 'azstacsandboxndcdev'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
